import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 lg:py-36 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20background%20with%20rich%20amber%20and%20golden%20tones%20soft%20gradient%20cinematic%20lighting%20elegant%20texture%20editorial%20photography%20style%20warm%20moody%20vibe%20sophisticated%20depth%20dramatic%20yet%20warm%20aesthetic&width=1800&height=800&seq=cta-bg-911&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 flex flex-col items-center text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-white tracking-wider uppercase mb-4">
          不想错过任何大瓜？
        </h2>
        <p className="text-white/80 text-sm md:text-base max-w-lg mb-8">
          订阅911爆料网，最新网红黑料<br />明星八卦第一时间送达
        </p>
        <Link
          to="/category/chigua-qianxian"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-white font-medium text-sm rounded-full group hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <span className="w-6 h-6 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-notification-3-line text-white text-xs"></i>
          </span>
          立即订阅
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </Link>
      </div>
    </section>
  );
}